import React, { useEffect, useState } from "react";

import * as S from "./styles";
import {
  BoldTitle,
  Button,
  FH,
  Input,
  Label,
  Text,
  TextDate,
  Title,
} from "../../main-styles";
import { useNavigate } from "react-router";
import WhiteBox from "../../../components/WhiteBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoin, faMinusCircle } from "@fortawesome/pro-light-svg-icons";
import { useTheme } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { clearCart, removeItem } from "../../../redux/slices/cartSlice";
import { createOrder } from "../../../api/orders";
import { getSaldo } from "../../../api/orgadots";
import { useConfirm } from "../../../components/ConfirmProvider";
import toast from "react-hot-toast";

const MOCK_PEDIDO = {
  id: 1,
  status: "Em separação",
  data: "2025-06-01",
  valor: 1000,
  timeline: [
    {
      status: "Solicitado",
      data: "2025-06-01 08:30",
    },
    {
      status: "Criado",
      data: "2025-06-01 08:42",
    },
    {
      status: "Faturado",
      data: "2025-06-01 09:00",
    },
    {
      status: "Em separação",
      data: "2025-06-01 09:00",
    },
    {
      status: "Separado",
      data: "2025-06-01 10:00",
    },
  ],
  itens: [
    {
      id: 1,
      nome: "Caneca de Café",
      imagem: "/assets/produtos/image-0.png",
      quantidade: 22,
      valor: 500,
    },
    {
      id: 2,
      nome: "Canivete Suíço",
      imagem: "/assets/produtos/image-1.png",
      quantidade: 100,
      valor: 1000,
    },
  ],
};

function Carrinho() {
  window.document.title = "Organnact - Carrinho de Compras";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const { cartReducer, authReducer } = useSelector((state) => state);
  const { items } = cartReducer;
  const { user } = authReducer;
  const confirm = useConfirm();
  const [saldo, setSaldo] = useState(0);
  const [valorOrgadots, setValorOrgadots] = useState(0);

  const totalPedido = items.reduce(
    (acc, item) => acc + item.preco * item.quantidade,
    0
  );
  const valorFaturado = Math.max(0, totalPedido - valorOrgadots);

  useEffect(() => {
    if (user?.id) {
      getSaldo(user.id)
        .then((data) => setSaldo(parseFloat(data.saldo) || 0))
        .catch(() => {});
    }
  }, [user?.id]);

  async function _removeItem(itemId) {
    if (
      !(await confirm({
        title: "Remover item",
        message: "Tem certeza que deseja remover este item do carrinho?",
        confirmText: "Remover",
        danger: true,
      }))
    ) {
      return;
    }
    dispatch(removeItem(itemId));
  }

  async function _finalizarCompra() {
    if (valorOrgadots > saldo) {
      toast.error("Saldo OrgaDots insuficiente");
      return;
    }
    if (
      !(await confirm({
        title: "Finalizar compra",
        message: "Tem certeza que deseja finalizar a compra?",
        confirmText: "Finalizar",
      }))
    ) {
      return;
    }
    try {
      let response = await createOrder(items, valorOrgadots);
      if (response) {
        dispatch(clearCart());
        navigate(`/pedidos/${response.id}`);
      } else {
        toast.error("Erro ao finalizar compra. Tente novamente mais tarde.");
      }
    } catch (e) {
      toast.error(e.message || "Erro ao finalizar compra");
    }
  }

  if (items.length === 0) {
    return (
      <S.Container>
        <Title onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
          Voltar
        </Title>
        <WhiteBox>
          <BoldTitle>Carrinho</BoldTitle>
          <Text>Seu carrinho está vazio.</Text>
          <Button onClick={() => navigate("/")}>Adicionar itens</Button>
        </WhiteBox>
      </S.Container>
    );
  }

  return (
    <S.Container>
      <Title onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
        Voltar
      </Title>
      <FH style={{ width: "100%", justifyContent: "space-between" }}>
        <BoldTitle>Carrinho</BoldTitle>
      </FH>

      <WhiteBox>
        <Title>Itens no carrinho</Title>
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Produto</th>
              <th>Quantidade</th>
              <th>Valor</th>
              <th>Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td style={{ verticalAlign: "middle" }}>
                  <img
                    src={item.imagens[0]}
                    style={{
                      height: 50,
                      width: 50,
                      borderRadius: 5,
                      marginRight: 10,
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                    alt="Produto"
                  />
                  {item.nome}
                  {item.variantLabel && (
                    <span style={{ fontSize: 11, color: "#999", marginLeft: 5 }}>
                      ({item.variantLabel})
                    </span>
                  )}
                </td>
                <td style={{ verticalAlign: "middle" }}>{item.quantidade}</td>
                <td style={{ verticalAlign: "middle" }}>
                  <FontAwesomeIcon icon={faCoin} color={theme.primary} />{" "}
                  {item.preco}
                </td>
                <td style={{ verticalAlign: "middle" }}>
                  <FontAwesomeIcon icon={faCoin} color={theme.primary} />{" "}
                  {item.quantidade * item.preco}
                </td>
                <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                  <FontAwesomeIcon
                    icon={faMinusCircle}
                    color={"red"}
                    style={{ cursor: "pointer" }}
                    onClick={() => _removeItem(item.id)}
                  />
                </td>
              </tr>
            ))}
            <tr>
              <td
                colSpan={3}
                style={{ textAlign: "right", backgroundColor: "#d7d7d7" }}
              >
                <Text style={{ fontWeight: "bold", fontSize: 16 }}>
                  Valor total:
                </Text>
              </td>
              <td
                colSpan={2}
                style={{
                  verticalAlign: "middle",
                  backgroundColor: "#d7d7d7",
                }}
              >
                <FontAwesomeIcon icon={faCoin} color={theme.primary} />{" "}
                {items.reduce(
                  (acc, item) => acc + item.preco * item.quantidade,
                  0
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </WhiteBox>
      <WhiteBox style={{ marginTop: 20, backgroundColor: "#f4f4f4" }}>
        <div style={{ fontSize: 18, paddingBottom: 7 }}>
          Condições de pagamento
        </div>
        <ul>
          <li>
            <b>Pedidos até R$3999</b> boleto direto para 60 dias.
          </li>
          <li>
            <b>Pedidos de R$4000 - R$5999</b> em 45 / 75 dias.
          </li>
          <li>
            <b>Pedidos acima de R$6000</b> em 30/60/90 dias.
          </li>
        </ul>
        <Text>
          <b>
            Atenção Distribuidor: Programe-se com as suas compras de brindes!
          </b><br/><br/>
          Estes itens serão enviados junto com o seu próximo pedido de produtos
          Organnact.<br/>
          <br />O pedido de brindes deve ser feito respeitando a data de
          cadastro de bonificações, até o dia 15 de cada mês. Caso contrário,
          ele será faturado somente no mês seguinte, dentro deste período.
        </Text>
      </WhiteBox>
      <WhiteBox style={{ marginTop: 20 }}>
        <div style={{ fontSize: 18, paddingBottom: 7 }}>
          Pagar com OrgaDots
        </div>
        <Text style={{ color: "#999", fontSize: 12, marginBottom: 10 }}>
          Seu saldo disponível:{" "}
          <span style={{ fontWeight: 700, color: theme.primary }}>
            <FontAwesomeIcon icon={faCoin} />{" "}
            {saldo.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
          </span>
        </Text>
        {saldo <= 0 ? (
          <Text style={{ fontSize: 13, color: "#999" }}>
            Você ainda não possui saldo de OrgaDots para usar nesta compra.
          </Text>
        ) : (
          <>
            <Label>Quanto deseja usar de OrgaDots?</Label>
            <FH style={{ gap: 10, alignItems: "center" }}>
              <Input
                type="number"
                min={0}
                max={Math.min(saldo, totalPedido)}
                value={valorOrgadots}
                onChange={(e) => {
                  let val = parseFloat(e.target.value) || 0;
                  val = Math.min(val, saldo, totalPedido);
                  val = Math.max(0, val);
                  setValorOrgadots(val);
                }}
                style={{ width: 150, marginBottom: 0 }}
              />
              <input
                type="range"
                min={0}
                max={Math.min(saldo, totalPedido)}
                step={0.01}
                value={valorOrgadots}
                onChange={(e) => setValorOrgadots(parseFloat(e.target.value))}
                style={{ flex: 1 }}
              />
            </FH>
            <FH
              style={{
                justifyContent: "space-between",
                marginTop: 10,
                padding: "10px 0",
                borderTop: "1px solid #eee",
              }}
            >
              <div>
                <Text style={{ fontSize: 13, color: "#999" }}>Pago com OrgaDots:</Text>
                <Text style={{ fontWeight: 700, color: theme.primary }}>
                  <FontAwesomeIcon icon={faCoin} />{" "}
                  {valorOrgadots.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </Text>
              </div>
              <div>
                <Text style={{ fontSize: 13, color: "#999" }}>Valor faturado:</Text>
                <Text style={{ fontWeight: 700 }}>
                  <FontAwesomeIcon icon={faCoin} />{" "}
                  {valorFaturado.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                  })}
                </Text>
              </div>
            </FH>
          </>
        )}
      </WhiteBox>
      <WhiteBox style={{ marginTop: 20, textAlign: "center" }}>
        <Button onClick={_finalizarCompra}>Finalizar compra</Button>
        <Button
          style={{
            backgroundColor: "#e2e2e2",
            color: "#1d1d1d",
            marginTop: 5,
          }}
          onClick={() => navigate("/")}
        >
          Adicionar mais itens
        </Button>
      </WhiteBox>
    </S.Container>
  );
}

export default Carrinho;
